import { Link } from 'react-router-dom';
import { Mini1WaitLocation, Mini1WaitPhone, Mini1WaitPost, MiniBlackFaceBook, MiniBlackInstagram, MiniBlackTelegram, MiniBlackWhatsapp } from '../assets/icones/icones';
import logo_footer from '../assets/images/logo-footer.svg'
import './assets/css/footer.css';

const Footercom = () => {
    return (


        <footer style={{"background":"#203952"}}>
            <div className="flexRowBetCenter footer">
                <ul style={{"display":"flex","flexDirection":"column","alignContent":"flex-start","justifyContent":"center","alignItems":"flex-start"}}>
                    <li >
                        <Mini1WaitLocation />
                        <span> تهران، خیابان ولیعصر،بالاتر از مسجد بلال صداوسیما،خیابان شهید ابراهیم مهری،بن بست سوسن یکم،شماره 16</span>

                    </li>
                    <li>
                        <Mini1WaitPhone />
                        <a href={"tel:+989358341515"}><span>09358341515</span></a>
                        <a href={"tel:+982122038013"}><span>021-22038013</span></a>

                    </li>
                    <li>
                        <Mini1WaitPost />
                        <a href={"mailto:info@namaava.com"}> <span>info@namaava.com</span></a>

                    </li>
                </ul>

                <ul className='flexRowBetCenter'>
                    <li className={"footer-telegram"} >
                        <a href="https://telegram.me/namaava">
                            <MiniBlackTelegram />
                        </a>
                    </li>
                    <li className={"footer-watsapp"} >
                        <a href="https://wa.me/9358341515">
                            <MiniBlackWhatsapp />
                        </a>
                    </li>
                    <li className={"footer-instagram"} >
                        <a href="https://instagram.com/namaava/">
                            <MiniBlackInstagram />
                        </a>
                    </li>
                </ul>


            </div>
            <div style={{"paddingBottom":"20px","paddingTop":"14px","textAlign":"center","color":"white","fontSize":"11px","display":"block","lineHeight":"1.6","borderTop":"solid 1px #c4c3c336"}}>کلیه حقوق مادی و معنوی این سایت متعلق به موسسه فرهنگی هنری نماآوای زندگی است.طراحی توسط <a target="_blank" className="text-svg-hover-orange-bk" href="https://avayehoshmand.com/" title="آوای هوشمند" style={{color: 'white'}}> آوای هوشمند </a></div>

        </footer>
    )
}
export default Footercom;